import { formatMs } from './format-ms.js';

const easing = {
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  standard: 300,
  complex: 375,
  enteringScreen: 225,
  leavingScreen: 195
};
function createTransition(props = ['all'], options = {}) {
  const {
    duration: durationInput = 'standard',
    easing: easingInput = 'easeInOut',
    delay = 0
  } = options;
  const durationOption = duration[durationInput] || duration.standard;
  const easingOption = easing[easingInput] || easing.easeInOut;
  return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
}

export { createTransition, duration, easing };
